import {FC, useState} from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {Box, IconButton, TextField, Tooltip, Typography} from '@mui/material';

import {ImpersonationToken} from '@entities/user';
import {Dialog, DialogTitle} from '@shared/components';
import {useNotImplementedToast} from '@shared/hooks';

interface Props {
  token: ImpersonationToken | null;
  onClose: () => void;
}

export const GuestAccessDialog: FC<Props> = ({token, onClose}) => {
  const [isVisible, setIsVisible] = useState(false);
  // The client app has no known "open with token" URL yet
  const handleOpen = useNotImplementedToast(
    'Opening the app with this token is not wired up yet',
  );

  if (!token) {
    return null;
  }

  const expiresInMinutes = Math.round(token.expiresIn / 60);

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle title="Guest access" onClose={onClose} />

      <Box
        p={3}
        pt={0}
        display="flex"
        flexDirection="column"
        gap={1.5}
        minWidth={420}
      >
        <Typography variant="body2" color="text.secondary">
          One-time access token for this user, valid for {expiresInMinutes}{' '}
          minutes.
        </Typography>

        <Box display="flex" alignItems="center" gap={0.5}>
          <TextField
            fullWidth
            size="small"
            type={isVisible ? 'text' : 'password'}
            value={token.accessToken}
            slotProps={{htmlInput: {readOnly: true}}}
          />

          <Tooltip title={isVisible ? 'Hide token' : 'Show token'}>
            <IconButton onClick={() => setIsVisible(prev => !prev)}>
              {isVisible ? (
                <VisibilityOffOutlinedIcon />
              ) : (
                <VisibilityOutlinedIcon />
              )}
            </IconButton>
          </Tooltip>

          <Tooltip title="Copy token">
            <IconButton
              onClick={() =>
                void navigator.clipboard.writeText(token.accessToken)
              }
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Open">
            <IconButton onClick={handleOpen}>
              <OpenInNewOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Dialog>
  );
};
